import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';
import { AskHrChatFeatureId } from '@tellent-ask-hr/core-types';
import {
  ChatUserTemplatesViewComponent,
  TemplatesWelcomeComponent,
} from '@tellent-ask-hr/templates-smart-ui';

export const CHAT_FORMS_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Forms,
    welcomeCmp: TemplatesWelcomeComponent,
    activateCmp: ChatUserTemplatesViewComponent,
  },
});
